import axios from 'axios'
import Vapi from 'vuex-rest-api'

const api = new Vapi({
  axios,
  state: {
    feedbackList: [],
  },
})
  .get({
    action: 'getLastFeedback',
    property: 'lastFeedback',
    path: '/review',
    onSuccess(s, { data }) {
      s.lastFeedback = data[0]
    },
  })
  .get({
    action: 'getFeedback',
    property: 'feedbackList',
    path: '/review',
  })
  .post({
    action: 'addFeedback',
    property: 'addFeedbackResult',
    path: '/review',
  })
  .getStore({ namespaced: true })

export default api
